module.exports = __webpack_public_path__ + "img/ser5.1c41588a.png";